import { render, staticRenderFns } from "./PerbulanView.vue?vue&type=template&id=3c491a0b&scoped=true"
import script from "./PerbulanView.vue?vue&type=script&lang=js"
export * from "./PerbulanView.vue?vue&type=script&lang=js"
import style0 from "./PerbulanView.vue?vue&type=style&index=0&id=3c491a0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c491a0b",
  null
  
)

export default component.exports